import { CdkMenuTrigger } from '@angular/cdk/menu';
import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Case, CaseScore } from 'src/app/models/case';
import { CaseService } from 'src/app/services/case.service';

@Component({
  selector: 'app-case-score',
  templateUrl: './case-score.component.html',
  styleUrls: ['./case-score.component.scss']
})
export class CaseScoreComponent implements OnChanges {
  @Input() case?: Case;
  @Input() style: 'condensed' | 'expanded' = 'expanded';
  @Input() score: CaseScore = {
    global: 0,
    documentsCount: 0,
    documentsAccuracy: 0,
    documentsClasses: 0,
    temporalCoverage: 0
  }
  @Input() color: 'white' | 'main' = 'main';

  scoreTypes: string[] = ["global"]

  scoreType: string = "global";

  @ViewChild('trigger') trigger?: CdkMenuTrigger;

  constructor(
    private caseService: CaseService,
    private translate: TranslateService
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.case && this.case.niceClassification) {
      this.case.niceClassification.forEach((classNumber) => {
        if (!this.scoreTypes.includes(classNumber.toString())) {
          this.scoreTypes.push(classNumber.toString())
        }
      })
    }
  }

  tip(type: keyof CaseScore) {
    let message: string;
    let icon: string;
    let color: string;
    let key: string;
    switch (type) {
      case 'global':
        key = 'GLOBAL';
        break;
      case 'documentsCount':
        key = 'DOCUMENTS_COUNT';
        break;
      case 'documentsAccuracy':
        key = 'DOCUMENTS_ACCURACY';
        break;
      case 'documentsClasses':
        key = 'DOCUMENTS_TYPES';
        break;
      case 'temporalCoverage':
        key = 'TEMPORAL_COVERAGE';
        break;
      default:
        key = '';
    }
    if (this.score[type] < 0.25) {
      icon = 'error_outline';
      message = `CASE.SCORE.${key}_POOR`;
      color = 'red';
    } else if (this.score[type] < 0.50) {
      icon = 'tips_and_updates';
      message = `CASE.SCORE.${key}_LOW`;
      color = 'gold';
    } else if (this.score[type] < 0.75) {
      icon = 'tips_and_updates';
      message = `CASE.SCORE.${key}_MEDIUM`;
      color = 'gold';
    } else {
      icon = 'check_circle';
      message = `CASE.SCORE.${key}_GOOD`;
      color = 'green';
    }
    return {
      icon,
      color,
      message: this.translate.instant(message)
    }
  }

  async onScoreTypeChange(scoreType: string) {
    this.scoreType = scoreType;
    this.trigger?.close();
    if (this.case && this.case._id) {
      if (scoreType === "global") {
        this.score = this.case?.score;
      } else {
        this.score = await this.caseService.getScoreForClass(this.case._id, parseInt(scoreType));
      }
    }

  }

  getClass(classNumber?: string) {
    if (classNumber && classNumber !== "global") {
      return { classNumber }
    }
    if (this.scoreType === "global") {
      return undefined;
    }
    return { classNumber: this.scoreType }
  }

}
